'use client';

import { usePathname } from 'next/navigation';

const navPaths = [
  { path: '/', exact: true },
  { path: '/cars', exact: true },
  { path: '/collection', exact: false },
  { path: '/my-profile', exact: false },
  { path: '/terms-and-conditions', exact: false },
  { path: '/used', exact: false }
];

export const useHasBottomNav = (): boolean => {
  const pathname = usePathname();

  return navPaths.some(({ path, exact }) => {
    if (exact) {
      return pathname === path || pathname === `${path}/`;
    } else {
      return pathname === path || pathname?.startsWith(`${path}/`);
    }
  });
};
